import React from 'react';
import SVGInline from "react-svg-inline";
import injectSheet from 'react-jss';
import removeIcon from '../images/close_white.svg';

const CloseButton = (props, { closeToast }) => (
    <SVGInline
        width={"10px"}
        svg={removeIcon}
        className={props.classes.svgAlignment}
        fill='white'
        onClick={closeToast}
    />
);

const styles = {
    svgAlignment: {
        margin: 'auto',
        cursor: 'pointer',
        padding: '0 10px',
        fill: '#ffffff'
    }
}

export default (injectSheet(styles)(CloseButton));